import { PriceInterval, ProductPrice, ProductType } from 'src/app/interfaces/user';
import { environment } from 'src/environments/environment';

const CURRENCY_SYMBOLS: { [code: string]: string } = { gbp: '£' };

/** Formats a backend ProductPrice (amount in minor units) into a display string like '£39' or '£4.99'. */
export function formatProductPrice(price: ProductPrice): string {
  const symbol = CURRENCY_SYMBOLS[price.currency?.toLowerCase()] ?? '';
  const major = price.amount / 100;
  const text = Number.isInteger(major) ? `${major}` : major.toFixed(2);
  return `${symbol}${text}`;
}

export interface ProductPriceIdEntry {
  productType: ProductType;
  interval: PriceInterval;
  defaultPriceId: string;
}

/**
 * Ties a default Stripe price ID to the product and billing interval it represents. When /payment
 * returns a price for that product and interval, PaymentConfigService swaps the default price ID
 * for the backend's price ID at checkout (and exposes its amount for display). 
 * When a new product or interval becomes purchasable through /payment a new entry should be added.
 */
export const PRODUCT_PRICE_ID_ENTRIES: ProductPriceIdEntry[] = [
  { productType: ProductType.Premium, interval: 'year', defaultPriceId: environment.stripePlans.identiAlertAnnual },
  { productType: ProductType.Premium, interval: 'month', defaultPriceId: environment.stripePlans.identiAlertMonthly },
  { productType: ProductType.BasicPlus, interval: 'year', defaultPriceId: environment.stripePlans.identibasePlus },
  { productType: ProductType.Locator, interval: 'year', defaultPriceId: environment.stripePlans.smartTagSubscription },
];

/** Vet group identifier used in the /payment context. */
export const VET_GROUP_V4P = 'V4P';
